import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class WorkAttendanceStatisticsApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'WorkAttendanceStatistics'
  }

}
